import { NO_PEERS, type Peer, type PeerMap } from './peers';

/** Everyone else on one entity, held outside React state so the bridge can read and watch it directly. */
export type PeerStore = {
  /** Same array until a peer changes. */
  getList(): Peer[];
  subscribe(listener: () => void): () => void;
  update(change: (peers: PeerMap) => PeerMap): void;
};

export function createPeerStore(): PeerStore {
  let peers: PeerMap = NO_PEERS;
  let list: Peer[] = [];
  const listeners = new Set<() => void>();

  return {
    getList: () => list,
    subscribe(listener) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    update(change) {
      const next = change(peers);
      if (next === peers) return;
      peers = next;
      list = [...next.values()];
      listeners.forEach((listener) => listener());
    },
  };
}
